import { actionTypes } from '../constants';

export const toggleFilterVisibility = () => {
    return (dispatch, getState) => {
        const isFilterVisibleState = getState().reports.isFilterVisible;
        dispatch({ type: actionTypes.TOGGLE_FILTER_VISIBILITY, isFilterVisible: !isFilterVisibleState });
    };
};

export const setFilterVisibilityFromLS = (filterVisibilityFromLS) => {
    return (dispatch) => {
        dispatch({ type: actionTypes.TOGGLE_FILTER_VISIBILITY, isFilterVisible: filterVisibilityFromLS });
    };
};


export const openGenerateReportModal = (preselectedAsset = null) => {
    // reject DOM Event objects that can arrive if used directly as an onClick handler
    const asset = preselectedAsset && typeof preselectedAsset === 'object' && typeof preselectedAsset.preventDefault !== 'function'
        ? preselectedAsset
        : null;
    return dispatch => {
        dispatch({ type: actionTypes.OPEN_GENERATOR_MODAL, preselectedAsset: asset });
    };
};

export const openUploadReportModal = () => {
    return dispatch => {
        dispatch({ type: actionTypes.OPEN_UPLOAD_MODAL });
    };
};

